export default __webpack_public_path__ + "static/media/scfoundation-2.abb1405f.jpg";